module.exports = __webpack_public_path__ + "img/bilyoner.f0065ab2.png";